import React, { useContext, useMemo, useDebugValue, useCallback, useEffect, useState } from 'react'

import isEmpty from 'lodash/isEmpty'
// import useMountEffect from 'reacticoon/view/hook/useMountEffect'
import SecurityManager from 'modules/security/SecurityManager'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import InfoIcon from '@material-ui/icons/Info'
import { useCadUsefulData } from 'modules/cadUsefulData'
import SettingsContext from 'modules/settings/context'
import CadFactionContext from 'components/CadFactionContext'

const useCadFactionChooser = () => {
  const { loggedInFaction, setLoggedInFaction } = useContext(CadFactionContext)
  const setSelectedCadFaction = setLoggedInFaction
  const [isResolvingFaction, setIsResolvingFaction] = useState(true)
  const cadUsefulData = useCadUsefulData()
  const settings = useContext(SettingsContext)

  useDebugValue("useCadFactionChooser: " + loggedInFaction)

  const myCadJobs = cadUsefulData?.myCadJobs || []

  const options = useMemo(() => {
    if (!myCadJobs || !settings) {
      return []
    }

    const cadFactionsSetting = settings.find(s => s.name === 'cadFactions')
    if (!cadFactionsSetting || !cadFactionsSetting.value) {
      return []
    }

    return cadFactionsSetting.value
      .map(faction => {
        if (SecurityManager.hasPermission("api.cad") || SecurityManager.hasCadPermission(faction)) {
          return {
            label: myCadJobs.find(f => f.jobName === faction)?.jobLabel,
            value: faction,
          }
        }

        return null
      })
      .filter(Boolean)
  }, [myCadJobs, settings])

  // Auto-sélection si une seule faction disponible et aucune faction définie
  // OU suppression du localStorage si la faction n'est plus accessible
  useEffect(() => {
    if (options.length === 0) {
      return // Attendre que les options soient chargées
    }
    
    // Si la faction en localStorage n'est pas dans la liste des options accessibles, la supprimer
    if (loggedInFaction && !options.find(opt => opt.value === loggedInFaction)) {
      setSelectedCadFaction(null)
      setIsResolvingFaction(false)
      return
    }
    
    // Auto-sélection si une seule faction disponible et aucune faction définie
    if (!loggedInFaction && options.length === 1) {
      setSelectedCadFaction(options[0].value)
      setIsResolvingFaction(false)
      return
    }
    
    // Sinon, on a fini de résoudre
    setIsResolvingFaction(false)
  }, [loggedInFaction, options, setSelectedCadFaction])

  const selectedOption = useMemo(() => {
    return options.find(opt => opt.value === loggedInFaction) || null
  }, [options, loggedInFaction])

  const renderChooseFactionView = useCallback(() => {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        py={6}
        px={3}
      >
        <InfoIcon style={{ fontSize: 48, color: '#2196f3', marginBottom: 16 }} />
        <Typography variant="h6" gutterBottom style={{ fontWeight: 500 }}>
          Sélection de faction requise
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          Veuillez sélectionner une faction dans la liste déroulante ci-dessus pour accéder au CAD.
        </Typography>
      </Box>
    )
  }, [])

  return {
    loggedInFaction,
    options,
    setSelectedCadFaction,
    renderChooseFactionView,
    isResolvingFaction,
  }
}

export default useCadFactionChooser